import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getCookie } from 'utils/Helper';
import { user_ip } from 'Api/Api';

export const HubspotForm = ({ portalId, formId }) => {
//export function hubspotForm ({ portalId, formId }) {
  const [data, setData] = useState()
  const [url, setUrl] = useState(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`
  )
  const [field_data_object, setFieldDataObject] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const fetchData = async () => {
    setIsError(false)
    setIsLoading(true)
    try {
      /*
      const formData = new FormData(form)
      const data = {
        fields: []
      }
      for (var pair of formData.entries()) {
        data.fields.push({ name: pair[0], value: pair[1] })
      }
      */
      let field_data_array = [];
      for (const [key, value] of Object.entries(field_data_object)) {
        field_data_array.push({ name: key, value: value });
      }
      let hutk_cookie_value = getCookie('hubspotutk');
      const request_data = {
        fields: field_data_array,
        context: {
          hutk: hutk_cookie_value,
          ipAddress: user_ip || '127.0.0.1',
          pageUri: window.location.href
        }
      }
      console.log("HubspotApi",request_data);
      const result = await axios({
        method: 'post',
        url,
        data: request_data,
        headers: {
          'Content-Type': 'application/json'
        }
      })
      setData(result)
      setFieldDataObject(false)
    } catch (e) {
      setIsError(true)
      setFieldDataObject(false)
    }

    setIsLoading(false)
  }

  useEffect(
    () => {
      if (field_data_object) {
        fetchData()
      }
    },
    [field_data_object]
  )

  const handleSubmit = (field_data_object) => {
    setFieldDataObject(field_data_object);
  }

  return { hubspot_response_data: data, isHubspotLoading: isLoading, isHubspotError: isError, handleHubspotSubmit: handleSubmit }
}

//export default hubspotForm;